import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=458b0180&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('458b0180')) {
      api.createRecord('458b0180', component.options)
    } else {
      api.reload('458b0180', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=458b0180&", function () {
      api.rerender('458b0180', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2yKOn6QKw6xUf/JS/offershelp.vue"
export default component.exports